export default function TermsPage() {
  return (
    <div className="prose w-full max-w-4xl py-10">
      <h1>Terms of Service</h1>
      <p>Last updated: November 20, 2025</p>

      <h2>Agreement</h2>
      <p>
        By accessing or using Quizzler, you agree to these Terms. If you do not agree, do not use the service. We may
        update the Terms; continued use means you accept the changes.
      </p>

      <h2>Who we are</h2>
      <p>Quizzler is operated by Keypath Labs.</p>

      <h2>Use of the service</h2>
      <ul>
        <li>No accounts are required to use the practice content.</li>
        <li>Use the site only for lawful purposes and in accordance with these Terms.</li>
        <li>You may not attempt to disrupt the service, bypass security, or reverse engineer it.</li>
      </ul>

      <h2>Content</h2>
      <p>
        All site content is provided by Keypath Labs. Users cannot submit their own questions or materials. You receive a
        limited, revocable license to access and use the content for personal, non-commercial study.
      </p>

      <h2>Advertising</h2>
      <p>
        The site may display Google Ads. Ad partners may use cookies or similar technologies as described in our Privacy
        Policy.
      </p>

      <h2>Intellectual property</h2>
      <p>All rights in the site and its content belong to Keypath Labs or its licensors. No other rights are granted.</p>

      <h2>Disclaimers</h2>
      <p>
        The service is provided "as is" without warranties of any kind. We do not warrant that the site will be
        uninterrupted, secure, or error-free, or that results will meet your requirements.
      </p>

      <h2>Limitation of liability</h2>
      <p>
        To the fullest extent permitted by law, Keypath Labs is not liable for indirect, incidental, special, or
        consequential damages, or loss of data, arising from your use of the service. Our total liability for any claim
        is limited to fifty U.S. dollars (US$50) or the amount you paid to use the service (if any), whichever is less.
      </p>

      <h2>Indemnity</h2>
      <p>You agree to indemnify and hold Keypath Labs harmless from claims arising out of your misuse of the service.</p>

      <h2>Termination</h2>
      <p>
        We may suspend or terminate access at any time for any reason, including if we believe you have breached these
        Terms.
      </p>

      <h2>Governing law</h2>
      <p>
        These Terms are governed by the laws of Canada. Any disputes will be handled in courts located in Canada. If your
        local law requires otherwise, your mandatory consumer rights remain unaffected.
      </p>

      <h2>Contact</h2>
      <p>
        For questions about these Terms, email <a href="mailto:support@keypathlabs.com">support@keypathlabs.com</a>.
      </p>

      <h2>DMCA / copyright</h2>
      <p>
        Send copyright notices to <a href="mailto:dmca@keypathlabs.com">dmca@keypathlabs.com</a> with sufficient detail
        to identify the material and your ownership.
      </p>
    </div>
  );
}
